import { Component, h } from 'preact'
import { ResultFilters } from '../commons/result-filters.component';
import { LocationSearchBox } from '../commons/location-search.component';
import { Location, DivCat, PropertyFilters } from '../../../../types';
import { ResultsPageBundle } from 'results-page-bundle.model';
import { ToggleSwitch } from '../commons/toggle-switch.component';
import getStore from '../../store';
import URLRouter from '../../../../core/url-router';
import { TOGGLE_MAP } from '../../reducers/results/results.actions';
import { ResultsCategoryToggle } from './results-category-toggle.component';
import { propertyTypes, FurnishingChoices } from '../../../../constants';
import { mediaBreakpointUp } from '../../../helpers/breakpoints';
import { readSharedJSON } from '../../../../utils/shared-data';
import { hiShowCustomerChat, hiHideCustomerChat } from '../../../helpers/customer-chat-loader';
import { PlatformUtility } from '../../../utils/platform-utility';

declare var window: Window;
declare var document: Document;

interface ResultsFilterProps {
  sharedResult?: ResultsPageBundle;
}

interface ResultsFilterState {
  filtersOpen?: boolean;
  sharedResult?: ResultsPageBundle;
  divCat?: DivCat;
  location?: Location;

  includePreselling?: boolean;
}

export class ResultsPageFilters extends Component<ResultsFilterProps, ResultsFilterState> {
  initialFormState: PropertyFilters;

  constructor(props: ResultsFilterProps) {
    super(props);

    this.setState({
      filtersOpen: false,
      includePreselling: true
    });

    if (PlatformUtility.isOnClient()) {
      this.handleSharedData();
    } else if (props.sharedResult) {
      const { division, category, type } = props.sharedResult;
      this.setState({
        sharedResult: props.sharedResult,
        divCat: { division, category, type }
      });
    }
  }

  componentDidMount() {
    if (PlatformUtility.isOnClient()) {
      const hash = window.location.hash;
      if (hash && hash.toLowerCase() == '#filtersopen') {
        this.setState({ filtersOpen: true });
      }
    }
  }

  readSharedData(id: string): string {
    const element = document.getElementById(id);

    if (element) {
      const json = element.innerHTML.replace(/&quot;/g, '"');
      return json;
    }
  }

  handleSharedData() {
    if (!this.state.sharedResult) {
      const sharedResult = readSharedJSON<ResultsPageBundle>('hiResultsDivCat');
      let divCat: DivCat = sharedResult as DivCat;

      // console.log('Shared Result!', sharedResult);

      // Duplicate. Necessary to work around VS Code not detecting ResultsPageBundle's
      // inheritance of DivCat
      this.setState({
        sharedResult: sharedResult,
        divCat: divCat
      });
    }

    this.initialFormState = readSharedJSON('hiFormDefaults') || {};
    
    if (this.initialFormState.preSale != undefined) {
      this.setState({
        includePreselling: this.initialFormState.preSale != '0'
      });
    }

    if (this.initialFormState['bedrooms']) {
      this.initialFormState.bedroomFilter = this.convertCommasToArray(
        this.initialFormState['bedrooms'], 'number'
      );
    }

    if (this.initialFormState['bathrooms']) {
      this.initialFormState.bathroomFilter = this.convertCommasToArray(
        this.initialFormState['bathrooms'], 'number'
      );
    }

    if (this.initialFormState['restRoom']) {
      this.initialFormState.restroomFilter = this.convertCommasToArray(
        this.initialFormState['restRoom'], 'number'
      );
    }

    if (this.initialFormState['parkingSpaces']) {
      this.initialFormState.parkingSpaceFilter = this.convertCommasToArray(
        this.initialFormState['parkingSpaces'], 'number'
      );
    }

    if (this.initialFormState.furnished && this.initialFormState.furnished.length > 0) {
      const prefilledFormState = this.handleFurnishingPrefill(this.initialFormState)
      this.initialFormState = prefilledFormState;
    }
  }

  // Can be moved into its own util exported class/function
  convertCommasToArray(field: any, type?: string) {

    let split = field.split(',');

    if (type === 'number') {
      split = split.map(member => Number.parseInt(member));
    }

    return split;
  }

  handleFurnishingPrefill(initialFormState: PropertyFilters) {
    const furnishings: string[] = initialFormState.furnished.split(',');

    let newFormState: PropertyFilters = Object.assign(
      {},
      initialFormState
    );

    furnishings.forEach(member => {
      const found = FurnishingChoices.find(choice => {
        return member == choice.value;
      });

      if (found) {
        newFormState[found.fieldName] = true;
      }
    })

    return newFormState;
  }

  onSearch = () => {
    console.log('Search!');
  }

  toggleFilters = () => {
    const hash = window.location.hash;
    const mapBtn = window.document.getElementById('hiResultsMapMobileToggle');
    const msgrIcon = window.document.querySelector('.fb_dialog_content')

    if (this.state.filtersOpen && hash && hash.toLowerCase() == '#filtersopen') {
      window.location.hash = '';
    }
    
    this.setState({
      filtersOpen: !this.state.filtersOpen
    });

    if (this.state.filtersOpen == true) {
      mapBtn.classList.add('d-none')
      msgrIcon.classList.add('d-none')
    } else {
      mapBtn.classList.remove('d-none')
      msgrIcon.classList.remove('d-none')
    }

    const smScreen = 768
    if (this.state.filtersOpen && window.innerWidth <= smScreen) {
      document.body.style.overflow  = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }

  getFilterSection(props, state: ResultsFilterState) {
    if (state.filtersOpen) {
      return (
        <div class="container p-4 hi-results-page__filter-bar__filter-wrapper">

          <div class="row d-none d-md-flex d-lg-none">
            <div class="col-6">
              <ResultsCategoryToggle 
                divCat={state.divCat}
                onCategoryChange={(divCat: DivCat) => this.onCategoryChange(divCat)}
                locationPermalink={state.sharedResult.locationPermalink}
              >
              </ResultsCategoryToggle>
            </div>
            <div class="col-6">
              <select class="hi-results-page__filter-bar__type-select form-control w-100" value={state.divCat.type}
                onChange={((event) => this.onTypeSelected(state, event.target['value']))}>
                {
                  this.getAvailableTypes(props, state).map(propType => (
                    <option value={propType.label}>{ propType.label }</option>
                  ))
                }
              </select>
            </div>
          </div>

          <ResultFilters isResultsPage={true} onSearch={this.onSearch}
            location={state.location} resultBundle={state.sharedResult}
            includePreselling={!!state.includePreselling}
            divCat={state.divCat} initialFormState={this.initialFormState}/>
        </div>
      );
    } else {
      return null;
    }
  }

  onSearchBoxLocationSelected(location: Location) {
    this.setState({ location });

    if (!this.state.filtersOpen) {
      URLRouter.navigateToURL(location.permalink);
    }
  }

  setDivCat = (searchBoxDivCatSetter: Function) => {

  }

  onPresellingToggleChange(state: ResultsFilterState, includePreselling: boolean) {
    // console.log('Pre-selling toggled', newState);

    this.setState({
      includePreselling: includePreselling
    });

    if (!this.state.filtersOpen) {
      const divCat = state.divCat;
      let queryParams = '';

      if (!includePreselling) {
        queryParams = '?preSale=0';
      }
    
      const url = URLRouter.buildResultsURL(divCat);
      URLRouter.navigateToURL(`/${url}${state.sharedResult.locationPermalink}${queryParams}`);
    }
  }

  toggleColumnClasses(isMapShown: boolean) {
    const elements = document.querySelectorAll('[listing-column]');
    const listContainer = document.getElementById('hiResultsPageContainer');

    // The property cards to smush if using col-4 with
    // any width less than 1600px. If less, use col-6.
    // This is very meh? since JS now intervenes with
    // responsiveness.

    const isTriCol: boolean = document.documentElement.clientWidth > 1599;
    const marginClass: string = isTriCol ? 'mx-5' : 'mx-1';

    elements.forEach(el => {
      if (isMapShown) {
        if (!isTriCol) {
          el.classList.add('col-xl-6');
          el.classList.remove('col-xl-4');
        }
        listContainer.classList.add(marginClass);
      } else {
        if (!isTriCol) {
          el.classList.add('col-xl-4');
          el.classList.remove('col-xl-6');
        }
        listContainer.classList.remove(marginClass);
      }
    });
  }

  onMapToggleChange(newState: boolean) {
    const container = document.getElementById('hiResultsPageMapDesktop');

    // check if there is a desktop map
    if (container) {
      const isHidden = container.classList.contains('d-none');

      if (isHidden) {
        hiHideCustomerChat();
        container.classList.remove('d-none');
        this.toggleColumnClasses(true);
      } else {
        hiShowCustomerChat();
        container.classList.add('d-none');
        this.toggleColumnClasses(false);
      }
    } else {
      const mobileContainer = document.getElementById('hiResultsPageMapMobile');

      if (mobileContainer) {
        const resultsBlockNode = document.getElementById('hiResultsPageContainer');
        const seoBlockNode = document.getElementById('hiResultsPageSeo');
        const footerNode = document.getElementById('hiResultsPageFooter');
        const isMobileVisible = mobileContainer.classList.contains('visible');

        if (isMobileVisible) {
          mobileContainer.classList.remove('visible');
          mobileContainer.classList.remove('mobile');
          resultsBlockNode.classList.remove('d-none');

          if (seoBlockNode) {
            seoBlockNode.classList.remove('d-none');
          }

          if (footerNode) {
            footerNode.classList.remove('d-none');
          }

        } else {
          mobileContainer.classList.add('visible');
          mobileContainer.classList.add('mobile');
          resultsBlockNode.classList.add('d-none');

          if (seoBlockNode) {
            seoBlockNode.classList.add('d-none');
          }

          if (footerNode) {
            footerNode.classList.add('d-none');
          }
        }
      }
    }

    const store = getStore();
    store.dispatch({
      type: TOGGLE_MAP
    });
  }

  getInitialSearchBoxText(state: ResultsFilterState): string {
    const sharedResult = state.sharedResult;
    if (sharedResult && sharedResult.level != 'Top') {

      if (sharedResult.label.includes('&amp;')) {
        sharedResult.label = sharedResult.label.replace(/&amp;/g, '&');
      }

      return sharedResult.label
    } else {
      return '';
    }
  }

  getTypeCatRowClasses(props, state: ResultsFilterState) {
    const alwaysApplied = 'hi-results-page__filter-bar__type-cat-row order-8 order-md-1';
    if (state.filtersOpen) {
      return `${alwaysApplied} filters-open`;
    } else {
      return alwaysApplied;
    }
  }

  getAvailableTypes(props, state: ResultsFilterState) {
    const divCat = state.divCat;
    
    return propertyTypes.filter(propType => {
      let rentMatch: boolean, saleMatch: boolean;
      rentMatch = divCat.category == 'Rent' && propType.hasRent;
      saleMatch = divCat.category == 'Sale' && propType.hasSale
      return rentMatch || saleMatch;
    });
  }

  onTypeSelected(state: ResultsFilterState, typeString: string) {
    const newDivCat: DivCat = Object.assign(state.divCat, { type: typeString });
    this.setState({ divCat: newDivCat });
  
    if (mediaBreakpointUp('lg')) {
      const url = URLRouter.buildResultsURL(newDivCat);
      URLRouter.navigateToURL(`/${url}${state.sharedResult.locationPermalink}`);
    }
  }

  onCategoryChange(divCat: DivCat) {
    this.setState({
      divCat: divCat
    });
  }

  getFilterBarClasses(props, state: ResultsFilterState) {
    const alwaysApplied = 'hi-results-page__filter-bar';
    if (state.filtersOpen) {
      return `${alwaysApplied} filters-open`;
    } else {
      return alwaysApplied;
    }
  }

  getPresellingToggle(props, state: ResultsFilterState) {
    if (state.divCat.category == 'Sale') {
      return (
        <ToggleSwitch   
            label='Include pre-selling units'
            initialState={state.includePreselling}
            onChange={(newVal) => this.onPresellingToggleChange(state, newVal)}>
        </ToggleSwitch>
      );
    } else {
      return (<div class="flex-1"></div>);
    }
  }

  render(props, state: ResultsFilterState) {
    return (
      <div class={this.getFilterBarClasses(props, state)}>
        <div class="container hi-results-page__filter-bar__container">
          <div class={this.getTypeCatRowClasses(props, state)}>

            <ResultsCategoryToggle divCat={state.divCat}
              onCategoryChange={(divCat: DivCat) => this.onCategoryChange(divCat)}
              locationPermalink={state.sharedResult.locationPermalink}>
            </ResultsCategoryToggle>

            <select class="hi-results-page__filter-bar__type-select form-control ml-3" value={state.divCat.type}
              onChange={((event) => this.onTypeSelected(state, event.target['value']))}>
              {
                this.getAvailableTypes(props, state).map(propType => (
                  <option value={propType.label}>{ propType.label }</option>
                ))
              }
            </select>
          </div>

          <div class="order-3">
            <LocationSearchBox
              onLocationSelected={(loc) => this.onSearchBoxLocationSelected(loc)}
              initialDivCat={state.divCat} setDivCat={this.setDivCat}
              initialText={this.getInitialSearchBoxText(state)}>
            </LocationSearchBox>
          </div>

          <div class="hi-results-page__filter-bar__toggle-group order-6">
            <div class="d-none d-md-block">
              <ToggleSwitch label='Show map'
                initialState={false}
                onChange={(newState) => this.onMapToggleChange(newState)}>
              </ToggleSwitch>
            </div>

            {/* { this.getPresellingToggle(props, state) } */}

            <button
              class="btn hi-type-caps p-0 d-none d-md-block" 
              onClick={this.toggleFilters}>
              Set Filters
            </button>

            <button class="btn hi-type-caps p-0 d-md-none" onClick={this.toggleFilters}>
              { state.filtersOpen ? 'Close' : 'Set Filters' }
            </button>
          </div>
        </div>

        { this.getFilterSection(props, state) }
      </div>
    );
  }
}